export function buildEmptyPartnerSettingsForm() {
  return {
    minimumWithdrawalAmount: '5000',
    walletCurrency: 'USD',
    walletCurrencyLocked: false,
  };
}
